import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertButton(component) {
  var properties = component.properties;
  var props = properties;
  return {
    brick: "eo-button",
    properties: _objectSpread(_objectSpread({}, props), {}, {
      themeVariant: "elevo"
    })
  };
}
//# sourceMappingURL=convertButton.js.map